import { render, staticRenderFns } from "./spelttjlaw.vue?vue&type=template&id=5e76f3d8&scoped=true&"
import script from "./spelttjlaw.vue?vue&type=script&lang=js&"
export * from "./spelttjlaw.vue?vue&type=script&lang=js&"
import style0 from "./spelttjlaw.vue?vue&type=style&index=0&id=5e76f3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76f3d8",
  null
  
)

export default component.exports